<template>
	<div>
		<b-row class="tabs-style-mobile text-center" no-gutters>
			<b-col cols="auto">
				<b-button variant="primary" @click="prevTab"><md-icon icon="arrow_left"/></b-button>
			</b-col>
			<b-col>
				<div class="col-title">
					<span>{{currentTabTitle}}</span>
				</div>
			</b-col>
			<b-col cols="auto">
				<b-button variant="primary" @click="nextTab"><md-icon icon="arrow_right"/></b-button>
			</b-col>
		</b-row>
		<b-tabs
			pills
			no-fade
			card
			small
			vertical
			v-model="currentTabIndex"
			nav-class="tabs-style"
			class="tabs-body-style"
			@activate-tab="(newIndex,prevIndex) => $emit('activate-tab',newIndex, prevIndex)"
		>
			<slot :loaded-index="loadedIndex"/>
		</b-tabs>
	</div>
</template>

<script>
  export default {
	props: {
	},
	computed: {
		currentTabTitle(){
			if (this.currentTabIndex >= 0 && this.currentTabIndex<this.$slots.default.length) {
				return this.$slots.default[this.currentTabIndex].componentOptions?.propsData?.title
			}
			return ''
		},
		maxTabs(){
			return this.defaultSlots.length
		},
		defaultSlots(){
			return this.$slots.default
		}
	},
	methods: {
		nextTab(){
			this.currentTabIndex++
		},
		prevTab(){
			this.currentTabIndex--
		},
	},
	data(){
		return {
			title:'',
			loadedIndex:[0],
			currentTabIndex : 0,
		}
	},
	mounted(){
	}
  }
</script>

<style scoped>
	.col-title{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		border-top: 1px solid #343a40;
		border-bottom: 1px solid #343a40;
	}
</style>
<style>
	.tabs-style{
		padding: .5rem;
	}
	.tabs-style-mobile{
		display: none;
	}
	.tabs-style-mobile{
		/*border: 1px solid #000;*/
	}
	@media (max-width: 1000px){
		.tabs-style-mobile{
			display: flex;
			justify-content: space-between;
		}
		.tabs-style{
			display: none;
		}
		.tabs-body-style .tab-pane{
			padding: 0;
		}
	}
</style>
